jQuery(function($) {

	/*
	 * See on others loaded scripts as : fancybox.js, infinite-scroll.js 
	 */

	$.wholeClick( '.whole-click', '.whole-click-target' );
	// $.scrollToHash( window.location.hash, $('#header').height() );

	//$('.text-toggle-container').textToggle();
	$('.noclick, .noclick a').stopClick(); // Stop click on specific link
	
	// $('a[href*="#"]').scrollToHash({
	// 	offset: $('#header').height()
	// });
	
	$('#header').stickyHeader({
		offset: $('#header').height()
	});

	
	$('.navbar-toggle-panel').navbarCollapse({
		showChildren: false,
		iconCaretOpen: 'fa-angle-down',
		iconCaretClose: 'fa-angle-right',
		openFirstItem: true,
		toggleParentOnly: false,
		append: [
			$('#footer #social-links'),
			$('.navbar-additional-link')
		]
	}).on('navchildtoggle', function(e, current, open) {
	
	});

	$('#header-search-toggle').each(function () {
		let $this = $(this);
		let $btn = $(this).find('.toggle-search');

		$btn.on('click', function (e) {
			e.preventDefault();
			let $target = $( $(this).data('target') );
			//$target.toggleClass('in').toggle();

			$.fancybox.open({
				src: $target,
				type: 'inline',
				buttons : [
					'close'
				]
			});

			$this.toggleClass('in');
		})
	});

	$('.filter-toggle').each(function () {
		let $elm = $(this);
		let $btn = $(this).find('.filter-btn-toggle');
		$btn.on('click', function(e) {
			e.preventDefault();
			$elm.toggleClass('in');
		});
	});

	/*$('.sticky-container').each(function() {
		var offset = parseInt( $('#header').innerHeight() );
		if( $('.sticky-sidebar').data('sticky-sidebar-offset') ) offset += parseInt($('.sticky-sidebar').data('sticky-sidebar-offset'));
		if( $('.sticky-container').data('sticky-sidebar-offset') ) offset += parseInt($('.sticky-container').data('sticky-sidebar-offset'));
		
        $('.sticky-container, .sticky-sidebar').theiaStickySidebar({
            additionalMarginTop: offset
        });
    });*/

	// Formulaire pied de page
    let form = $('#gform_3');
    let footer = form.find('.gform_footer');
    let emailContainer = form.find('.ginput_container_email');
    emailContainer.append(footer);

	// Mettre en couleurs les 3 premiers mots du titre pour les pages simple référence et expertise
	$('.header-article .main-title').each(function() {
        var text = $(this).text();
        var words = text.split(' '); 
        if (words.length > 3) {
            var firstThree = words.slice(0, 3).join(' ');
            var rest = words.slice(3).join(' ');
            
            // Vérifie la classe du body et modifie seulement la classe du span
            var spanClass = $('body').hasClass('single-cp_references') ? 'colored-reference' : 'colored-expertise';
            
            $(this).html('<span class="' + spanClass + '">' + firstThree + '</span> ' + rest);
        }
    });

	// Image (rgaa)
	$('img').not('.logo-std, .img-logo-customer').each(function () {
		$(this).attr('alt', '');
	
		if ($(this).attr('title')) {
			$(this).removeAttr('title');
		}
	
		$(this).attr('aria-hidden', 'true');
	});

    // Récupère les paramètres de l'URL
    const params = new URLSearchParams(window.location.search);
    const besoin = params.get("besoin"); // Pour le select input_1_15
    const type = params.get("type");     // Pour l'input texte input_1_16

    // Met à jour le <select> si la valeur existe et correspond à une option
    const $selectElement = $("#input_1_15");
    if (besoin && $selectElement.length && $selectElement.find(`option[value="${besoin}"]`).length) {
        $selectElement.val(besoin);
    }

    // Met à jour l'<input> texte si la valeur existe
    const $inputElement = $("#input_1_16");
    if (type && $inputElement.length) {
        $inputElement.val(type);
    }

	// Supprimer les <br> de l'input Type du formulaire contact
	setTimeout(function() {
        $('.expertise_type .ginput_container select option').each(function() {
            let decodedText = $("<textarea/>").html($(this).html()).text();
            let cleanedText = decodedText.replace(/<br\s*\/?>/gi, ' ').trim();
            $(this).text(cleanedText);
        });
    }, 100);

	// Scroll Top
	var $scrollTopBtn = $("#top");

    toggleScrollTopButton();

    $(window).scroll(function () {
        toggleScrollTopButton();
    });

    function toggleScrollTopButton() {
        if ($(window).scrollTop() > 0) {
            $scrollTopBtn.addClass("show");
        } else {
            $scrollTopBtn.removeClass("show");
        }
    }

    $scrollTopBtn.click(function (e) {
        e.preventDefault();
        $("html, body").animate({ scrollTop: 0 }, 600);
    });
	
});

function socialsharing_popup(em){
	let shareurl=em.href;
	let top = (screen.availHeight - 500) / 2;
	let left = (screen.availWidth - 500) / 2;
	let popup = window.open(
		shareurl,
		'social sharing',
		'width=550,height=420,left='+ left +',top='+ top +',location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1'
	);
	return false;
}

// Swiper.js (Base)
let testimonialSwiper = new Swiper(".testimonial-swiper", {
	spaceBetween: 30,
	keyboard: {
        enabled: true,
    },
	autoplay: {
	 	delay: 5000,
	},
	navigation: {
		nextEl: "#nextTestimonialArrow",
        prevEl: "#prevTestimonialArrow",
	},
});

let refsSwiper = new Swiper(".refs-swiper", {
	slidesPerView: 1,
    spaceBetween: 10,
	keyboard: {
        enabled: true,
    },
	autoplay: {
	 	delay: 5000,
	},
	navigation: {
		nextEl: "#refArrowNext",
        prevEl: "#refArrowPrev",
	},
	pagination: {
        el: ".swiper-pagination",
    },
	breakpoints: {
		768: {
			slidesPerView: 1,
			spaceBetween: 30,
		},
		991: {
			slidesPerView: 1,
			spaceBetween: 30,
		},
		1110: {
			slidesPerView: 2,
			spaceBetween: 30,
		},
		1650: {
			slidesPerView: 3,
			spaceBetween: 30,
		},
	},
});

let refsRelatedSwiper = new Swiper(".refs-related-swiper", {
	keyboard: {
        enabled: true,
    },
	autoplay: {
	 	delay: 5000,
	},
	navigation: {
		nextEl: "#refArrowNext",
        prevEl: "#refArrowPrev",
	},
	pagination: {
        el: ".swiper-pagination",
    },
	breakpoints: {
		720: {
			slidesPerView: 1,
			spaceBetween: 30,
		},
		944: {
			slidesPerView: 2,
			spaceBetween: 30,
		},
	},
});

